export default __webpack_public_path__ + "static/media/Ellipse 6.8815a2a6.png";